/**
 * Zod schemas + types for the concept-group prevalence endpoint.
 *
 * Validated at the trust boundary per the frontend rules — the static
 * type is derived via `z.infer` and exported alongside the schema so
 * callers don't have to choose.
 */

// TODO: cleanup with concept_group_prevalence_preview ff

import { z } from 'zod';

export const ConceptGroupDomainPrevalenceSchema = z.object({
  domain: z.string(),
  nSubjects: z.number().int().nonnegative(),
  nEvents: z.number().int().nonnegative(),
  prevalencePct: z.number().nullable().optional(),
  sampleSizeWarning: z.string().nullable().optional(),
});
export type ConceptGroupDomainPrevalence = z.infer<typeof ConceptGroupDomainPrevalenceSchema>;

export const ConceptGroupPrevalenceSchema = z.object({
  conceptGroupId: z.string(),
  datasetReleaseId: z.string(),
  totalPersonsInDataset: z.number().int().nonnegative().nullable().optional(),
  domains: z.array(ConceptGroupDomainPrevalenceSchema),
  computedAt: z.string(),
});
export type ConceptGroupPrevalence = z.infer<typeof ConceptGroupPrevalenceSchema>;

// Matches ObjectResponseSchema[ConceptGroupPrevalenceResponseSchema] from the
// gateway — a thin envelope around `data`.
export const ConceptGroupPrevalenceEnvelopeSchema = z.object({
  data: ConceptGroupPrevalenceSchema,
});
